interface SuggestionMessageData { id: number; name: string; city: string; comment: string; created_at: string }
const messageDate = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', dateStyle: 'medium' });
const messageTime = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', timeStyle: 'short' });

export function SuggestionMessage({ suggestion }: { suggestion: SuggestionMessageData }) {
  const sentAt = new Date(suggestion.created_at);
  const initials = suggestion.name.trim().split(/\s+/).slice(0, 2).map((part) => part.charAt(0)).join('').toLocaleUpperCase('pt-BR');
  return <li className="suggestion-message">
    <div className="suggestion-message-heading">
      <span className="suggestion-message-avatar" aria-hidden="true">{initials}</span>
      <div className="suggestion-message-author"><strong>{suggestion.name}</strong><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></svg>{suggestion.city}</span></div>
      <time className="suggestion-message-date" dateTime={suggestion.created_at} title="Horário de Brasília"><span>{messageDate.format(sentAt)}</span><small>{messageTime.format(sentAt)} · Brasília</small></time>
    </div>
    <div className="suggestion-message-body"><span className="suggestion-message-label">Mensagem</span><p>{suggestion.comment}</p></div>
  </li>;
}
